import React, { useState } from 'react';
import { FaExchangeAlt, FaCheckCircle, FaStoreAlt } from 'react-icons/fa';
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogClose } from "@/components/ui/dialog";

const OurPolicy = () => {
  const [open, setOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');

  const openModal = (content) => {
    setModalContent(content);
    setOpen(true);
  }

  return (
    <div className="flex flex-col sm:flex-row justify-between gap-6 sm:gap-12 text-center py-20 px-6 text-xs sm:text-sm md:text-base text-gray-700">

      {/* Mobile View: All three in one row, hide other texts */}
      <div className="sm:hidden flex flex-row justify-between w-full">

        <div className="flex flex-col items-center">
          <FaExchangeAlt className="text-4xl text-black mb-4" />
          <p className="font-semibold">Effortless Installation</p>
        </div>

        <div className="flex flex-col items-center">
          <FaCheckCircle className="text-4xl text-black mb-4" />
          <p className="font-semibold">Uncompromising Quality</p>
        </div>

        <div className="flex flex-col items-center">
          <FaStoreAlt className="text-4xl text-black mb-4" />
          <p className="font-semibold">In-Person Assistance</p>
        </div>

      </div>

      {/* Desktop View: Card layout with modal */}
      <div className="hidden sm:flex sm:flex-row sm:justify-between gap-6">

        {/* Effortless Installation */}
        <div className="flex flex-col items-center bg-white shadow-lg rounded-lg p-6 transition-all hover:scale-105 hover:shadow-2xl flex-grow">
          <FaExchangeAlt className="text-4xl text-black mb-4 transition-transform transform hover:rotate-12" />
          <p className="font-serif text-base sm:text-lg md:text-xl font-semibold leading-tight text-black">Effortless Installation</p>
          <p className="text-gray-500 mt-2">At Sahla Curtain Center, we provide professional curtain installation services. Our experts ensure that your curtains are installed seamlessly, with minimal disruption, and maximum satisfaction.</p>
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
              <a href="javascript:void(0)" className="mt-3 text-blue-500 hover:text-blue-700 text-sm" onClick={() => openModal('Effortless Installation')}>Learn More</a>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Effortless Installation</DialogTitle>
                <DialogDescription>
                  <p className="text-sm text-gray-500">
                    At Sahla Curtain Center, we believe that the installation process should be as easy as possible for our customers. Our professional team ensures a quick and seamless installation experience, leaving you with beautifully hung curtains that perfectly complement your space.
                  </p>
                </DialogDescription>
                <DialogClose className="mt-4 text-blue-500 hover:text-blue-700">Close</DialogClose>
              </DialogHeader>
            </DialogContent>
          </Dialog>
        </div>

        {/* Uncompromising Quality */}
        <div className="flex flex-col items-center bg-white shadow-lg rounded-lg p-6 transition-all hover:scale-105 hover:shadow-2xl flex-grow">
          <FaCheckCircle className="text-4xl text-black mb-4 transition-transform transform hover:scale-125" />
          <p className="font-serif text-base sm:text-lg md:text-xl font-semibold leading-tight text-black">Uncompromising Quality</p>
          <p className="text-gray-500 mt-2">We take great pride in offering curtains made from the finest materials, ensuring long-lasting beauty and durability for every piece.</p>
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
              <a href="javascript:void(0)" className="mt-3 text-blue-500 hover:text-blue-700 text-sm" onClick={() => openModal('Uncompromising Quality')}>Learn More</a>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Uncompromising Quality</DialogTitle>
                <DialogDescription>
                  <p className="text-sm text-gray-500">
                    At Sahla Curtain Center, we are committed to providing curtains of the highest quality. Our materials are carefully selected to ensure they not only look beautiful but also stand the test of time. We believe in delivering products that offer both beauty and durability for every customer.
                  </p>
                </DialogDescription>
                <DialogClose className="mt-4 text-blue-500 hover:text-blue-700">Close</DialogClose>
              </DialogHeader>
            </DialogContent>
          </Dialog>
        </div>

        {/* In-Person Assistance */}
        <div className="flex flex-col items-center bg-white shadow-lg rounded-lg p-6 transition-all hover:scale-105 hover:shadow-2xl flex-grow">
          <FaStoreAlt className="text-4xl text-black mb-4 transition-transform transform hover:scale-110" />
          <p className="font-serif text-base sm:text-lg md:text-xl font-semibold leading-tight text-black">In-Person Assistance</p>
          <p className="text-gray-500 mt-2">Visit our offline store for personalized assistance, expert advice, and hands-on support in selecting the perfect curtains for your home.</p>
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
              <a href="javascript:void(0)" className="mt-3 text-blue-500 hover:text-blue-700 text-sm" onClick={() => openModal('In-Person Assistance')}>Learn More</a>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>In-Person Assistance</DialogTitle>
                <DialogDescription>
                  <p className="text-sm text-gray-500">
                    Our offline store is the perfect place to receive personalized support. At Sahla Curtain Center, we offer expert advice and hands-on assistance to help you choose the perfect curtains for your space. Visit us today to get a personalized consultation with our team.
                  </p>
                </DialogDescription>
                <DialogClose className="mt-4 text-blue-500 hover:text-blue-700">Close</DialogClose>
              </DialogHeader>
            </DialogContent>
          </Dialog>
        </div>

      </div>
    </div>
  )
}

export default OurPolicy;
